export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/set.json")),
  ), //make sure all the values are deeply cloned
  {
    category: "gravity",
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "gravity",
            title: "property",
            "hard-lock": true,
            editable: false,
          },
        },
        {
          name: "number",
        },
      ],
    },
  },
);
